import Wallop from "wallop";
import PubSub from "underpub-js";
import URI from "urijs";

var LanguageSelector = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

	this.$closeButton = this.options.$el.find(".close-button");
	this.$modalContainer = this.options.$el.find(".modal-container");

	// properties to create our url
	this.regionId = false;
	this.language = false;
	this.subdomain = false;

};

LanguageSelector.prototype.init = function () {

	var self = this;
	var el = this.options.$el.find(".Wallop")[0];
	this.$gallery = new Wallop(el);

	setTimeout(function(){
		var height = self.$modalContainer.height();
		self.$modalContainer.height(height);
	}, 1000);

	this.$closeButton.on("click", function(){
		self.hide();
	});

	PubSub.subscribe("showLanguageSelectorModal", function(){
		self.show();
	});

	this.options.$el.find(".region-item").on("click", function(){
		var $el = $(this);
		self.regionId = $el.data("region-id");
		console.log(self.buildUrl());
		window.location = self.buildUrl();
	});

	this.options.$el.find(".language-item").on("click", function(){

		var $el = $(this);
		self.language = $el.data("language").toLowerCase();
		self.subdomain = $el.data("subdomain").toLowerCase();
		// self.$gallery.next();
		window.location = self.buildUrl();

	});

};

/*
Building our URL
 */
LanguageSelector.prototype.buildUrl = function(){

	let newUrl = false;
	let parsedUrl = false;
	let self = this;
	let subdomain = self.subdomain;

	newUrl = decodeURIComponent(self.options.$el.data("url"));
	newUrl = URI(newUrl).subdomain(subdomain).href();
	// newUrl = encodeURIComponent(newUrl);
	newUrl = newUrl.replace(".dev", ".com");
	newUrl = newUrl.replace("authenticff.", "jsheld.");

	// newUrl = "/redirects/regions?regionId=" + self.regionId + "&newUrl=" + newUrl;

	return newUrl;

};

LanguageSelector.prototype.show = function(){

	this.$gallery.goTo(0);
	this.options.$el.addClass("is-active");

};

LanguageSelector.prototype.hide = function(){

	this.options.$el.removeClass("is-active");

};

export default LanguageSelector;
